import { useContext, useState, useRef, useEffect } from "react";
import { Handle, Position, useUpdateNodeInternals } from "@xyflow/react";
import { StoreContext } from "../../store/Store";
import { GlobalRefContext } from "../../store/GlobalRefs";
import { actionTypes } from "../../store/storeTypes";
import { buttonStyles, handleStyles ,handleStyle} from "./customNodeStyles";
import { onNodeClick } from "./customNodeFunctions";
import { SelectFromDropdown } from "../SelectFromDropdown";
import SingleFileUploader from "../upload/SingleFileUploader";
import { PopupLabel } from "../PopupLabel";
import { Undo } from "../Undo";

export const CustomNode = ({ data }) => {
  const [store, dispatch] = useContext(StoreContext);
  const grefs = useContext(GlobalRefContext);
  const {nodes, mode, showHandles } = store;
  const [selectedHandle, setSelectedHandle] = useState(null);
  const [positions, setPositions] = useState(null);
  const nodeRef = useRef(null);
  const updateNodeInternals = useUpdateNodeInternals();

  const bStyles = buttonStyles(data,grefs);

  useEffect(() => {
    if (data.handles) {
      setPositions({
        target: data.handles.target,
        source:
          data.id in grefs.nodesWithoutSources.current
            ? null
            : data.handles.source,
      });
    }
  }, [data, grefs.nodesWithoutSources]);

  const onHandleSelect = (type) => {
    setSelectedHandle(type);
  };

  const onNodeClickWrapper = (ev, button) => {
    ev.stopPropagation();
    onNodeClick(
      ev,
      button,
      selectedHandle,
      nodeRef,
      positions,
      setPositions,
      updateNodeInternals,
      data,
      grefs,
      dispatch,
      actionTypes,
      mode,
      nodes
    );
  };
  
  return positions ? (
    <>    
      {showHandles && (
        <>
          <div
            style={{
              ...handleStyles()[positions.target],
              backgroundColor: selectedHandle === "target" ? "red" : "orange",
            }}
            onClick={() => onHandleSelect("target")}
          ></div>
          <div
            style={{
              ...handleStyles()[positions.source],
              backgroundColor: selectedHandle === "source" ? "red" : "orange",
            }}
            onClick={() => onHandleSelect("source")}
          ></div>
        </>
      )}
      <div
        ref={nodeRef}
        style={{ ...data.style, width: undefined }}
        onClick={(ev) => onNodeClickWrapper(ev, "")}
      >
        <Undo data={data}/>

        {data.label}
        <PopupLabel data={data} />
        <SingleFileUploader data={data}/>
        {positions.source && (
          <div style={bStyles.panel}>
            <div
              style={bStyles.yes}
              onClick={(ev) => onNodeClickWrapper(ev, "yes")}
            >
              YES
            </div>
            <div
              style={bStyles.no}
              onClick={(ev) => onNodeClickWrapper(ev, "no")}
            >
              NO
            </div>
            <div
              style={bStyles.next}
              onClick={(ev) => onNodeClickWrapper(ev, "next")}
            >
              NEXT
            </div>
          </div>
        )}
        <SelectFromDropdown data={data} />
        
      </div>

      {positions.target && (
        <Handle style={handleStyle(data,grefs,"target")} type="target" position={Position[positions.target]} />
      )}
      {positions.source && (
        <Handle
          style={handleStyle(data,grefs,"source")} 
          type="source"
          position={Position[positions.source]}
        />
      )}
    </>
  ) : null;
};
